import { Component, input, OnInit } from "@angular/core";

import { FilterMilestoneTypes, ManualFlagStatus } from "@modules/global-dashboard/models/global-dashboard-interface";
import { MilestoneTypeName } from "@shared/models/pay-cycle.interface";

@Component({
	selector: "app-highlight-automation",
	templateUrl: "./highlight-automation.component.html",
	styleUrls: ["./highlight-automation.component.scss"]
})
export class HighlightAutomationComponent implements OnInit {
	manualFlagStatus = input.required<ManualFlagStatus>();
	milestoneType = input.required<FilterMilestoneTypes | MilestoneTypeName>();
	isHighlighted = false;
	isManualIconVisible = false;
	ManualFlagStatus = ManualFlagStatus;

	ngOnInit(): void {
		if (this.manualFlagStatus() === ManualFlagStatus.MANUAL) {
			this.isManualIconVisible = true;
		}
		if (this.manualFlagStatus() === ManualFlagStatus.MANUAL_HIGHLIGHTED) {
			this.isManualIconVisible = true;
			this.isHighlighted = true;
			this.milestoneToolTipText();
		}
	}

	/**
	 * @returns: tooltip text for milestone flag
	 */
	milestoneToolTipText(): string {
		return this.milestoneType() === FilterMilestoneTypes.FUNDING || this.milestoneType() === "FUNDING_DATE"
			? "Funding request is available for download"
			: "Milestone is ready to take action";
	}
}
